var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnrich(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600.76 600.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#021689;}.cls-2{fill:#e63612;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.38,
    cy: 300.38,
    r: 300.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,440.23c-77.12,0-139.86-62.74-139.86-139.85S222.91,160.52,300,160.52s139.85,62.74,139.85,139.86S377.14,440.23,300,440.23Zm0-265.16a125.31,125.31,0,1,0,125.3,125.31A125.45,125.45,0,0,0,300,175.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.75,405.6a109,109,0,0,1-53.33-13.92l7.34-13.05a94.29,94.29,0,0,0,80.16,5.59l5.44,13.95A108.58,108.58,0,0,1,301.75,405.6Zm45.62-183.47a94,94,0,0,0-46-12v-15a108.93,108.93,0,0,1,53.32,13.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.03,
    y: 337.24,
    width: 14.18,
    height: 167.38,
    transform: "translate(-138.11 580.57) rotate(-55.72)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrich);
export default __webpack_public_path__ + "static/media/enrich.7eb97fc7653add87c660f7c369291e64.svg";
export { ForwardRef as ReactComponent };